import qs from 'qs'

export async function post(url, data = {}) {
  const apiRoot = window.apiRoot ?? 'http://localhost:8000/api';

  const result = await fetch(`${apiRoot}${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  if (result.ok) {
    return await result.json()
  }

  if (result.status < 500) {
    return await result.json()
  }

  return null
}

export async function request(url, query = null) {
  const apiRoot = window.apiRoot ?? 'http://localhost:8000/api';

  url = url.replace(apiRoot, '')

  console.log(
    query ? `${apiRoot}${url}?${qs.stringify(query)}` : `${apiRoot}${url}`
  )

  const result = query
    ? await fetch(`${apiRoot}${url}?${qs.stringify(query)}`)
    : await fetch(`${apiRoot}${url}`);

  if (result.ok) {
    return await result.json()
  }

  return null
}
